import { render, staticRenderFns } from "./ClearCacheButton.vue?vue&type=template&id=1bf0de1d&"
import script from "./ClearCacheButton.vue?vue&type=script&lang=js&"
export * from "./ClearCacheButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports